import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "./assets/tailwind.css"
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/messaging'
import 'firebase/auth'
import Toasted from 'vue-toasted';
// @todo remove manual pollyfill
import 'core-js/stable'

Vue.use(Toasted)

firebase.initializeApp({
  apiKey: "AIzaSyB8iUtVB1yrqol7b9JOUD16HWi_gN4-EA4",
  authDomain: "crypto-coin-prod.firebaseapp.com",
  databaseURL: "https://crypto-coin-prod.firebaseio.com",
  projectId: "crypto-coin-prod",
  storageBucket: "crypto-coin-prod.appspot.com",
  messagingSenderId: "700420771648",
  appId: "1:700420771648:web:1f73966f8fe0ea39c7f4a5",
  measurementId: "G-DTBV1BWNBE"
})


Vue.config.productionTip = false;

Vue.prototype.$firebase = firebase
Vue.prototype.$firestore = firebase.firestore()
Vue.prototype.$auth = firebase.auth()
if (firebase.messaging.isSupported()) {
  Vue.prototype.$messaging = firebase.messaging()
}
// Vue.prototype.$messaging.usePublicVapidKey('BN3bQ9yoHto3VxAZHRtc8C4UtdRi9U8fQMYSwloTHpTw4ubLryh46FvgiOsZllqHq5wNGoS8m_Ssgbje2cShKvQ')

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
